<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="activity.causer"/>

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}

    <!--CREATED-->
    <div v-if="activity.description === 'added'">
      <div v-if="activity.subject">
        <span> {{ $t('systems.network.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.network.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.subject.system.slug }}"
        >
            {{activity.properties.system.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('systems.network.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.network.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.properties.system.slug }}"
        >
            {{activity.properties.system.name}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">
      <div v-if="activity.subject">
        <span> {{ $t('systems.network.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.network.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.subject.system.slug }}"
        >
            {{activity.properties.system.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('systems.network.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.network.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.properties.system.slug }}"
        >
            {{activity.properties.system.name}}
        </router-link>
      </div>
    </div>

    <!--UPDATED-->
    <div v-if="activity.description === 'updated'">
      <div v-if="activity.subject">
        <span> {{ $t('systems.network.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.network.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.subject.system.slug }}"
        >
            {{activity.properties.attributes.system.name}}
        </router-link>
      </div>

      <div v-else>
        <span> {{ $t('systems.network.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.attributes.network.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.properties.attributes.system.slug }}"
        >
            {{activity.properties.attributes.system.name}}
        </router-link>
      </div>

      <div v-if="changes">
        <div class="mt-2 small">
          <span class="text-warning text-bold">
            {{ $t('activities.log.changes')}}
          </span>
        </div>
        <div v-for="(item, index) in activity.properties.attributes">
          <div v-if="item !== activity.properties.old[index]">
            <span class="small" v-if="!isObject(item)">
              <span class="text-bold">{{makeTitle(index)}}</span>
              <span> {{ $t('activities.log.changed_to')}} </span>
              <span v-if="index === 'updated_at'" class="text-bold">
                {{item | formatDate}}
              </span>
              <span v-else class="text-bold">{{item}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'SystemNetwork',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
